"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const am4charts = __importStar(require("@amcharts/amcharts4/charts"));
const am4core = __importStar(require("@amcharts/amcharts4/core"));
const mui_1 = require("tss-react/mui");
const styles_1 = __importDefault(require("./styles"));
const CHART_ID = 'progressChart';
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const ProgressChart = ({ data }) => {
    const chartRef = (0, react_1.useRef)(null);
    const { classes, theme } = useStyles();
    (0, react_1.useEffect)(() => {
        const chart = am4core.create(chartRef.current || CHART_ID, am4charts.XYChart);
        chart.data = data;
        chart.responsive.enabled = true;
        chart.paddingLeft = 0;
        chart.paddingRight = 0;
        const yAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        yAxis.dataFields.category = 'label';
        yAxis.renderer.grid.template.disabled = true;
        yAxis.renderer.labels.template.disabled = true;
        const xAxis = chart.xAxes.push(new am4charts.ValueAxis());
        xAxis.renderer.grid.template.disabled = true;
        xAxis.renderer.labels.template.disabled = true;
        xAxis.min = 0;
        xAxis.max = data[data.length - 1].to;
        xAxis.strictMinMax = true;
        const series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueX = 'to';
        series.dataFields.openValueX = 'from';
        series.dataFields.categoryY = 'label';
        series.columns.template.propertyFields.fill = 'fill';
        series.columns.template.strokeOpacity = 0;
        series.columns.template.height = am4core.percent(100);
        const valueLabel = series.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.text = '{graphValue}';
        valueLabel.label.fontSize = 12;
        valueLabel.label.fill = theme.palette.primary.contrastText;
        valueLabel.label.truncate = false;
        valueLabel.label.hideOversized = false;
        valueLabel.locationX = 0.5;
        return () => {
            chart === null || chart === void 0 ? void 0 : chart.dispose();
        };
    }, [data, theme]);
    return (<div className={classes.progressChartWrapper}>
      <div id={CHART_ID} ref={chartRef} className={classes.progressChart}/>
    </div>);
};
exports.default = ProgressChart;
